/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Workout_Logging_Warmup_ForInputs */

const en_us2_workout_logging_warmup_for = /** @type {(inputs: Workout_Logging_Warmup_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`For ${i?.loadText} on the first set`)
};

const pt_br2_workout_logging_warmup_for = /** @type {(inputs: Workout_Logging_Warmup_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para ${i?.loadText} na primeira série`)
};

const es_419_workout_logging_warmup_for = /** @type {(inputs: Workout_Logging_Warmup_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para ${i?.loadText} en la primera serie`)
};

const pt_pt2_workout_logging_warmup_for = /** @type {(inputs: Workout_Logging_Warmup_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para ${i?.loadText} na primeira série`)
};

const fr_fr2_workout_logging_warmup_for = /** @type {(inputs: Workout_Logging_Warmup_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pour ${i?.loadText} à la première série`)
};

const de_de2_workout_logging_warmup_for = /** @type {(inputs: Workout_Logging_Warmup_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für ${i?.loadText} im ersten Satz`)
};

const it_it2_workout_logging_warmup_for = /** @type {(inputs: Workout_Logging_Warmup_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Per ${i?.loadText} nella prima serie`)
};

/**
* | output |
* | --- |
* | "For {loadText} on the first set" |
*
* @param {Workout_Logging_Warmup_ForInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_for = /** @type {((inputs: Workout_Logging_Warmup_ForInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_ForInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_for(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_for(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_for(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_for(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_for(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_for(inputs)
	return en_us2_workout_logging_warmup_for(inputs)
});
export { workout_logging_warmup_for as "workout-logging.warmup_for" }